<label class="checkbox-container ">{{label}}
    <input #checkbox type="checkbox" [checked]="checked" [disabled]="disabled" (click)="onClick()">
    <span class="check-mark"></span>
</label>
